import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-humidity-template',
  templateUrl: './humidity-template.component.html',
  styleUrls: ['./humidity-template.component.less']
})
export class HumidityTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
